var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Checkbox as RmwcCheckbox } from '@rmwc/checkbox';
/**
 * Checkbox component. Checkboxes allow the user to select multiple options from a set.
 *
 * **Functional Spec:** https://github.com/invotra/invotra-components-spec/blob/v0.2.1/content/components/checkbox.md
 */
export default function Checkbox(_a) {
    var onChange = _a.onChange, label = _a.label, props = __rest(_a, ["onChange", "label"]);
    return (React.createElement(RmwcCheckbox
    // @ts-ignore
    , __assign({ 
        // @ts-ignore
        label: label, role: "checkbox", onClick: function (event) { return event.stopPropagation(); }, onChange: function (event) { onChange && onChange(event.currentTarget.checked); } }, props)));
}
//# sourceMappingURL=Checkbox.js.map